import { render, staticRenderFns } from "./StateLabel.vue?vue&type=template&id=1fa9ae23&"
import script from "./StateLabel.vue?vue&type=script&lang=js&"
export * from "./StateLabel.vue?vue&type=script&lang=js&"
import style0 from "./StateLabel.vue?vue&type=style&index=0&id=1fa9ae23&prod&lang=scss&"
import style1 from "./StateLabel.vue?vue&type=style&index=1&id=1fa9ae23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports